module.exports = __webpack_public_path__ + "img/bg.42cf08c8.png";